import {Fragment} from 'react'
import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap'

import Modal from '../../../../../shared/components/Modals/Modal.jsx'
import H3TitleLeftAlign from "../../../../../shared/components/Styled/H3TitleLeftAlign.jsx"
import ParagraphLeftAlign from "../../../../../shared/components/Styled/ParagraphLeftAlign.jsx"
class MissionExampleModal extends Modal {
  constructor(props) {
    super(props)

    this.state = {
      updateText: false,
    }

    this.close = () => this.props.closeModal()
  }

  render() {
    const modalProps = {
      className: 'modal-mission-example'
    }

    const {job, company, period, template } = this.props.currentUniverseExample


    modalProps.toggle = this.close

    return (
      <BootstrapModal {...modalProps} isOpen={this.props.isOpen} size="lg">
        <ModalHeader {...modalProps}> Exemple </ModalHeader>
        <ModalBody>
          <Fragment>
            <H3TitleLeftAlign title={job}/>
            <ParagraphLeftAlign>
                chez <strong>{company}</strong>
            </ParagraphLeftAlign>
            <ParagraphLeftAlign>
              {period}
            </ParagraphLeftAlign>
            <div dangerouslySetInnerHTML={{__html: template}}/>
          </Fragment>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default MissionExampleModal
